import {EChannelType} from '../../constants';
import {TTariffChannelType} from '../TariffsCatalog';

export enum EOnboardingStep {
  COMPANY_DETAILS = 'COMPANY_DETAILS',
  CHANNEL = 'CHANNEL',
  LICENSE = 'LICENSE',
  INTEGRATION = 'INTEGRATION',
  TEMPLATE = 'TEMPLATE',
}

export enum EOnboardingStepStatus {
  COMPLETED = 'COMPLETED',
  IN_PROGRESS = 'IN_PROGRESS',
  INITIAL = 'INITIAL',
}

export type TOnboardingStep = {id: EOnboardingStep; status: EOnboardingStepStatus; date?: string};
export type TOnboardingSteps = Record<EOnboardingStep, TOnboardingStep>;

export type TOnboardingStepResponse = {
  matcherOnboardingStatus: EOnboardingStepStatus;
  integrationOnboardingStatus: EOnboardingStepStatus;
  profileOnboardingStatus: EOnboardingStepStatus;
  licenseOnboardingStatus: EOnboardingStepStatus;
  firstLicenseActivatedAt?: string;
};

export const DEFAULT_STEPS = {
  [EOnboardingStep.COMPANY_DETAILS]: {id: 'COMPANY_DETAILS', status: 'INITIAL'},
  [EOnboardingStep.CHANNEL]: {id: 'CHANNEL', status: 'INITIAL'},
  [EOnboardingStep.LICENSE]: {id: 'LICENSE', status: 'INITIAL'},
  [EOnboardingStep.INTEGRATION]: {id: 'INTEGRATION', status: 'INITIAL'},
  [EOnboardingStep.TEMPLATE]: {id: 'TEMPLATE', status: 'INITIAL'},
} as TOnboardingSteps;

export enum EOnboardingModule {
  MAX = 'MAX',
  DIALOGS = 'DIALOGS',
  TRIGGERS = 'TRIGGERS',
  CASCADES = 'CASCADES',
  INTEGRATION = 'INTEGRATION',
}

export enum EOnboardingSurvey {
  BROADCASTS = 'BROADCASTS',
  INCOMING_MESSAGES = 'INCOMING_MESSAGES',
  INTEGRATION = 'INTEGRATION',
  EASY_OPERATION = 'EASY_OPERATION',
}

export type TOnboardingChannelType = TTariffChannelType;

export const ONBOARDING_CHANNEL_TYPES: TOnboardingChannelType[] = [
  EChannelType.MAX_BOT,
  EChannelType.MAX,
  EChannelType.SMS,
  EChannelType.VIBER,
  EChannelType.WHATSAPP,
];

export enum EOnboardingTutorial {
  DIALOGS = 'DIALOGS',
  TRIGGERS = 'TRIGGERS',
  CASCADES = 'CASCADES',
  BROADCASTS = 'BROADCASTS',
}
